import React from 'react';
import { CheckIcon } from 'lucide-react';
const NUMBERS = [{
  value: '6',
  label: 'Complete Modules'
}, {
  value: '5',
  label: 'Strategic Bonuses'
}, {
  value: 'Pro',
  label: 'Professional Level'
}, {
  value: 'Complete',
  label: 'Teaching System'
}];
const COVERAGE = ['Lesson Planning', 'Grammar & Language', 'Real-Life Vocabulary', 'Speaking & Conversation', 'Ready-to-Use Activities', 'Student Progression', 'Assessment & Feedback', 'Teaching Continuity'];
export function SystemOverview() {
  return <section aria-labelledby="system-title" className="w-full bg-cream px-4 py-8" data-id="element-216" data-mp="px6ec9e3stkg">
      <div className="mx-auto max-w-4xl text-center" data-id="element-217" data-mp="13wpeog0ob0m7">
        <span className="font-head text-[10px] font-semibold uppercase tracking-[0.14em] text-brand sm:text-xs" data-id="element-218" data-mp="13u36ce5ykh2x">
          The complete system to stop recreating every lesson
        </span>
        <h2 id="system-title" className="mt-0.5 font-head text-2xl font-bold uppercase leading-none text-night sm:text-4xl" data-id="element-219" data-mp="2f9i2jfqcf4wz">
          Spanish Teacher Pro™
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-[12px] leading-snug text-night/70 sm:text-[15px]" data-id="element-220" data-mp="235cgvofnpooz">
          Lesson planning, grammar resources, real-life vocabulary, speaking practice, ready-to-use
          activities, progression and assessment. Everything is organized so you can select, adapt
          and use the right resources faster.
        </p>

        <dl className="mt-3 grid grid-cols-2 gap-1.5 lg:grid-cols-4" data-id="element-221" data-mp="1kfwf6xs8jq6z">
          {NUMBERS.map(item => <div key={item.label} className="rounded-xl border border-night/10 bg-white py-2.5" data-id="element-222" data-mp="1ke1tvid1xw2d">
              <dd className="font-head text-xl font-bold uppercase leading-none text-brand sm:text-3xl" data-id="element-223" data-mp="1pcmtbfkhcbpr">
                {item.value}
              </dd>
              <dt className="mt-0.5 text-[9px] font-semibold uppercase tracking-widest text-night/55 sm:text-[10px]" data-id="element-224" data-mp="1z5u5pkdn0rzc">
                {item.label}
              </dt>
            </div>)}
        </dl>

        <p className="mt-4 font-head text-sm font-bold uppercase tracking-wide text-night sm:text-lg" data-id="element-225" data-mp="16ng8nn04la1b">
          Complete coverage for your Spanish teaching
        </p>
        <ul className="mt-1.5 grid grid-cols-2 gap-1.5 text-left lg:grid-cols-4" data-id="element-226" data-mp="toyw6ib92u0p">
          {COVERAGE.map(item => <li key={item} className="flex items-start gap-1.5 rounded-lg border border-brand/25 bg-brand/5 px-2.5 py-1.5 text-[11px] font-semibold leading-snug text-night sm:text-[12px]" data-id="element-227" data-mp="18e4um429kg7j">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-228" data-mp="foo63hhrljgl" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}